export default __webpack_public_path__ + "static/event-socialmedia-3c33aae20d4649fbd290046ea790a668.jpg";